import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var SponsorsIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("g", {
                            clipPath: "url(#sponsers__a)",
                            children: _jsx("path", {
                                d: "M16.512 17.346h-5.08c.04-.19.07-.39.07-.59 0-.72-.28-1.39-.79-1.9l-1.85-1.85a4.192 4.192 0 00-2.96-1.23h-4.25c-.55-.01-1 .44-1 .99s.45 1 1 1h4.25c.29 0 .57.06.84.17.27.11.51.27.71.47l1.85 1.85c.13.13.2.3.2.49s-.07.36-.2.49c-.26.26-.72.26-.97 0l-1.19-1.19a.996.996 0 10-1.41 1.41l1.19 1.2c.51.51 1.18.79 1.9.79.23 0 .45-.04.67-.1h7.02c.91 0 1.65.74 1.65 1.65 0 .18-.15.33-.33.33H7.582c-.51 0-1.01-.18-1.4-.51l-3.89-3.24a1.001 1.001 0 10-1.28 1.54l3.89 3.24c.75.62 1.7.97 2.68.97h10.26c1.28 0 2.33-1.04 2.33-2.33 0-2.01-1.64-3.65-3.65-3.65h-.01zm6.74-11.949c-.09-.26-.24-.49-.45-.67-.21-.18-.47-.29-.73-.32l-2.77-.42-1.25-2.51v-.02c-.13-.24-.32-.44-.56-.58a1.25 1.25 0 00-.78-.2c-.27 0-.54.09-.76.23-.23.15-.41.36-.52.58l-1.24 2.51-2.78.41a1.454 1.454 0 00-1.15.99c-.08.26-.1.53-.03.79.06.26.19.5.4.71l1.99 1.91-.46 2.75c-.06.28-.04.56.07.83a1.48 1.48 0 001.3.94h.07c.26 0 .51-.07.7-.18l2.46-1.3 2.43 1.28c.24.14.52.21.81.2.28-.01.55-.11.78-.28.23-.17.4-.39.51-.66.1-.27.13-.55.08-.76l-.41-2.88 1.92-1.82c.2-.19.35-.43.42-.7.07-.27.06-.55-.02-.83h-.03zm-4.01 2.2a.92.92 0 00-.19.25c-.11.21-.17.44-.17.68 0 .16.03.32.08.47l.27 1.89-1.85-.98c-.2-.09-.41-.14-.63-.14-.22 0-.44.05-.69.16l-1.76.93.32-1.92c.05-.2.05-.41.02-.61-.04-.24-.15-.46-.3-.65-.03-.03-.05-.06-.08-.09l-1.44-1.38 1.9-.28c.25-.02.5-.12.7-.27.2-.15.36-.35.45-.54l.89-1.79.86 1.73c.1.23.26.43.47.59.2.15.44.24.65.26l1.96.3-1.45 1.38-.01.01z"
                            })
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "sponsers__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
SponsorsIcon.isCarinaIcon = true;
export default SponsorsIcon;
